/* RESPONSIBLE TEAM: team-proactive-support */
import NodeConfiguration, { NODE_CATEGORIES } from 'embercom/objects/series/node-configuration';
import WhatsappInserterConfiguration from 'embercom/objects/series/node/whatsapp-inserter-configuration';

export default class WhatsappNodeConfiguration extends NodeConfiguration {
  inserterConfiguration = new WhatsappInserterConfiguration();
  category = NODE_CATEGORIES.content;
}
